import { connect } from 'react-redux';

import { getLineItemProcessingQuantity } from '../selectors';
import { changeLineItemQuantity } from '../actions';

import { CartLineItem } from '../components/sidebar/CartLineItem';
import { buildLineItemPricing } from '../utils';

const mapStateToProps = (state, ownProps) => ({
  variants: state.variants,
  isMembershipOrder: state.currentOrder.membership_order,
  quantityProcessing: getLineItemProcessingQuantity(ownProps.item, state),
  disableQuantityInputForCommitmentRewards:
    typeof global.gon !== 'undefined' &&
    global.gon.current_store.region === 'europe',
  showStrikethroughPrices:
    typeof global.gon !== 'undefined' &&
    global.gon.current_store.preferences.show_strikethrough_prices,
  ...buildLineItemPricing(ownProps.item),
});

export const mapDispatchToProps = dispatch => ({
  handleQuantityChange: ({ quantity, lineItem }) => {
    dispatch(
      changeLineItemQuantity({
        lineItem,
        quantity,
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartLineItem);
